<template>
  <div class="order-details side" v-if="transaction">
    <span id="section-summary-heading" class="order-details-title uppercase" :aria-label="$t('orderDetails.headerAriaLabel')" :role="isPaywall ? 'heading' : undefined" :aria-level="isPaywall ? '2' : undefined">{{ $t('orderDetails.header') }}</span>

    <div class="amount-wrapper">
      <p>{{ $t('orderDetails.amountLabel') }}</p>
      <p>{{ getTransactionPayAmount() | amount }} {{ getTransactionPayCurrency() }}</p>
    </div>

    <div class="details-wrapper" v-if="showDetails">
      <order-details-cart v-if="isProductCartSet" />
      <div class="details-data" v-if="dccDetails">
        <p>{{ $t('orderDetails.amountOriginalCurrencyLabel') }}</p>
        <p>{{ getTransactionOryginalAmount() | amount }} {{ getTransactionOryginalCurrency() }}</p>
      </div>
      <div class="details-data" v-if="dccDetails">
        <p>{{ $t('orderDetails.currencyRateLabel') }}</p>
        <p>1 {{ getTransactionOryginalCurrency() }} = {{ getTransactionDccRate() }} {{ getTransactionPayCurrency() }}</p>
      </div>
      <div class="details-data" v-if="dccDetails || (visibility && visibility.showFrontFees)">
        <p v-if="dccDetails">{{ $t('orderDetails.feeLabelDcc') }}</p>
        <p v-else>{{ $t('orderDetails.feeLabel') }}</p>
        <p>
          <span v-if="dccDetails">
            {{ getTransactionCustomerFee() }}%
          </span>
          <span v-else>
            {{ getTransactionCustomerFee() | amount }} {{ transaction.payAmountCurrency }}
          </span>
        </p>
      </div>

      <div class="details-data" v-if="isBlikAuto">
        <p>{{ $t('orderDetails.blikReccuringNameLabel') }}</p>
        <p>{{ activePayway.additionalData?.label }}</p>
      </div>
      <div class="details-data" v-if="isBlikAuto">
        <p>{{ $t('orderDetails.blikReccuringFrequencyLabel') }}</p>
        <p>{{ $t('orderDetails.blikReccuringFrequencyText') }}</p>
      </div>
      <div class="details-data" v-if="isBlikAuto">
        <p>{{ $t('orderDetails.blikReccuringValidToLabel') }}</p>
        <p v-if="activePayway.additionalData?.validTo">{{ activePayway.additionalData?.validTo }}</p>
        <p v-else>{{ $t('orderDetails.blikReccuringValidToText') }}</p>
      </div>
      <div class="details-data">
        <p>{{ $t('orderDetails.orderLabel') }}</p>
        <p>
          <span aria-hidden="true">{{ transaction.orderId }}</span>
          <span class="sr-only">{{ formatOrderIdForScreenReader(transaction.orderId) }}</span>
        </p>
      </div>
      <div class="details-data">
        <p>{{ $t('orderDetails.receiverLabel') }}</p>
        <p v-html="transaction.receiverNameForFront"></p>
      </div>
      <div class="details-data" v-if="isServiceTypeMwf && transaction.customerNumber">
        <p>{{ $t('orderDetails.customerNumberLabel') }}</p>
        <p>{{ transaction.customerNumber }}</p>
      </div>
      <div class="details-data" v-if="isServiceTypeMwf && transaction.invoiceNumber">
        <p>{{ $t('orderDetails.invoiceNumberLabel') }}</p>
        <p>{{ transaction.invoiceNumber }}</p>
      </div>
      <div class="details-data" v-if="isServiceTypeMwf && transaction.accountNumber">
        <p>{{ $t('orderDetails.accountNumberLabel') }}</p>
        <p>{{ transaction.accountNumber }}</p>
      </div>
      <div class="details-data" v-if="payway">
        <p>{{ $t('orderDetails.paywayLabel') }}</p>
        <p>{{ $t('orderDetails.paywayName') }}</p>
      </div>
      <div class="details-data" v-if="payway">
        <p class="payway-img">
          <img :src="getPaywayImage(payway)" :alt="payway.nameOnList">
          <span>{{ payway.nameOnList }}</span>
        </p>
      </div>
    </div>

    <a class="show-more" href="" role="button" ref="moreDetailsButton" @keyup.32="toggleDetails" @click.prevent="showDetails = true" v-if="isProductCartSet && !showDetails">{{ $t('orderDetails.linkMore') }}</a>
    <a class="show-less" href="" role="button" ref="lessDetailsButton" @keyup.32="toggleDetails" @click.prevent="showDetails = false" v-if="isProductCartSet && showDetails">{{ $t('orderDetails.linkLess') }}</a>

    <div class="details-link" v-if="showButton && visibility && visibility.showReturnToShopButton">
      <button type="button"
              class="btn btn-plain link-back-to-shop"
              :title="$t('orderDetails.linkBackTitle')"
              v-if="allowReject"
              @click="sendPaymentReject">
        {{ $t('orderDetails.linkBack') }}
      </button>
      <button type="button"
              class="btn btn-plain link-back-to-shop"
              :title="$t('orderDetails.linkBack')"
              v-if="!allowReject"
              @click="goBackToShop(returnUrl)">
        {{ $t('orderDetails.linkBack') }}
      </button>
    </div>
  </div>
</template>

<script>
import orderDetailsMixin from '@/base/mixins/orderDetails.mixin'
import OrderDetailsCart from '@/base/components/OrderDetails/partial/cart'

export default {
  name: 'OrderDetailsSide',
  data () {
    return {
      showDetails: false
    }
  },
  components: { OrderDetailsCart },
  mixins: [orderDetailsMixin],
  methods: {
    toggleDetails () {
      this.showDetails = !this.showDetails
    }
  },
  mounted () {
    this.showDetails = !this.isProductCartSet
  },
  updated () {
    if (this.showDetails && this.$refs.lessDetailsButton) {
      this.$refs.lessDetailsButton.focus()
    }
    if (!this.showDetails && this.$refs.moreDetailsButton) {
       this.$refs.moreDetailsButton.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/base/assets/scss/components/OrderDetails.scss";
</style>
